/**
 * Allocated once when this module is first evaluated (main entry import).
 * Unchanged across react-router navigations; new value only after a full document load.
 */
function createBundleSessionId(): string {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID()
    }
    return `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`
}

const bundleSessionId = createBundleSessionId()

if (typeof window !== 'undefined') {
    window.__TICK2TRADE_EMBEDDED_BUNDLE_SESSION__ = bundleSessionId
}

export function getEmbeddedBundleSessionId(): string {
    return bundleSessionId
}
